module.exports = __webpack_public_path__ + "img/class Icono.50c57e66.svg";